import { Box } from "@mui/material";

import { GoHireHeader, UnlockAdvancedHiringTools } from "../../../components";

import JobsSummary from "./JobsSummary";
import JobTableList from "./JobTableList";
import TalentHeatMap from "./TalentHeatMap";

const JobsOverviewPage = () => {
  return (
    <Box sx={styles.container}>
      <GoHireHeader />
      <UnlockAdvancedHiringTools />
      <JobsSummary />
      <TalentHeatMap />
      <JobTableList />
    </Box>
  );
};

export default JobsOverviewPage;

const styles = {
  container: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: "24px",
  },
};
